import React, { useEffect, useState } from 'react';
import BasicInfoTab from './BasicInfoTab';
import FollowUpTab from './FollowUpTab';
import DocumentsTab from './DocumentsTab';
import styles from '../../styles/GestionInteresadosStyles/GestionInteresados.module.css';

function InterestDetailsModal({ prospect, isOpen, onClose, onUpdateEstado, onRefresh, openMode = 'view' }) {
  const [activeTab, setActiveTab] = useState('basic');
  const [footerActions, setFooterActions] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setActiveTab('basic');
    }
  }, [isOpen, openMode]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className={styles.modalOverlay} onClick={handleBackdropClick}>
      <div className={styles.detailsModalContainer}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>
            Detalles del Interesado: {prospect.nombre}
          </h2>
          <button className={styles.closeButton} onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        
        <div className={styles.modalTabs}>
          <button
            className={`${styles.tabButton} ${activeTab === 'basic' ? styles.tabActive : ''}`}
            onClick={() => handleTabChange('basic')}
          >
            Información Básica
          </button>
          <button
            className={`${styles.tabButton} ${activeTab === 'followup' ? styles.tabActive : ''}`}
            onClick={() => handleTabChange('followup')}
          >
            Seguimiento
          </button>
          <button
            className={`${styles.tabButton} ${activeTab === 'documents' ? styles.tabActive : ''}`}
            onClick={() => handleTabChange('documents')}
          >
            Expediente
          </button>
        </div>
        
        <div className={styles.modalContent}>
          {activeTab === 'basic' && <BasicInfoTab prospect={prospect} onUpdateEstado={onUpdateEstado} onRefresh={onRefresh} forceEdit={openMode === 'edit'} onFooterActionsChange={setFooterActions} />}
          {activeTab === 'followup' && <FollowUpTab prospect={prospect} onUpdateEstado={onUpdateEstado} onRefresh={onRefresh} />}
          {activeTab === 'documents' && <DocumentsTab prospect={prospect} />}
        </div>
        
        <div className={styles.modalFooter}>
          {footerActions?.showSave && (
            <div className={styles.modalFooterActions}>
              <button
                className={styles.modalPrimaryButton}
                onClick={footerActions.onSave}
                disabled={footerActions.disableSave}
              >
                {footerActions.saveLabel || 'GUARDAR CAMBIOS'}
              </button>
              <button
                className={styles.modalSecondaryButton}
                onClick={footerActions.onCancel}
                disabled={footerActions.disableCancel}
              >
                CANCELAR
              </button>
            </div>
          )}
          <button className={styles.modalCloseButton} onClick={onClose}>
            CERRAR
          </button>
        </div>
      </div>
    </div>
  );
}

export default InterestDetailsModal;
